document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.slider-with-background').forEach(function (section) {
        const sliderContainer = section.querySelector('.slider-container');

        if (sliderContainer && !sliderContainer.hasAttribute('data-initialized')) {
            new Splide(`#${sliderContainer.id}`, {
                type: 'loop',
                perPage: 1,
                autoplay: false,
                interval: 3000,
                pagination: true,
                arrows: false
            }).mount();

            sliderContainer.setAttribute('data-initialized', 'true');
        }
    });
});

